// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
        el.addEventListener( 'submit', function ( e ) {
            var search = el.querySelector( 'input' );
            if ( search.value.length < 1 ) {
                e.preventDefault();
                search.focus();
            }
        } );
    } );

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
    var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
        return new bootstrap.Popover( popoverTriggerEl, {
            trigger: 'focus',
        } );
    } );
} )();

$(document).ready(function() {
    $('.drawer').drawer();
});

$(function(){
    $(document)
        //scroll link action
        .on('click', 'a[href^="#pos"]', function(){
            var id= $(this).attr('href');
            var y = $(id).offset().top;
            if($('#btn-menu').is(':visible')){
                var h = $('#header').height();
                var y = y - (h * 1.1);
            }
            $('html,body').animate({scrollTop:y});
            return false;
        })

    /* scroll fix header
    --------------------------------------------------------------*/
    $(window).on('scroll load', function(){
        if($(this).scrollTop() > 350){
            if(!$('#header').hasClass('fix')){
                $('#header').removeClass('nofix').addClass('fix');
            }
        }else{
            if($('#header').hasClass('fix')){
                $('#header').removeClass('fix').addClass('nofix');
            }
        }
    });


    /* scroll action
    --------------------------------------------------------------*/
    var $scrollLink = $('.scroll-link');
    $scrollLink.hide()
    $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
            $scrollLink.fadeIn();
        } else {
            $scrollLink.fadeOut();
        }
    });

    $scrollLink.on('click', function(){
        // console.log('yes')
        var id = $(this).data('target');
        var h = $('#header').outerHeight();
        $("html,body").animate({scrollTop:$(id).offset().top - h});
        return false;
    })
});

//scroll fadein action
$(window).on('load scroll', function (){
    $('.fadein').each(function(i){
        var elme = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var winH = $(window).height();
        if (scroll > elme - winH){
            //$(this).delay(i*300).queue(function() {
                $(this).css({opacity:1, transform:'translateY(0)'});
            //})
        }
    });
});
